<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter paso="1" total-pasos="2" />

      <wrap-container class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              id="antetitulo"
              class="titulo antetitulo p28 light oscuro"
              v-if="config.pasos.celular.antetitulo"
              v-safe-html="config.pasos.celular.antetitulo"
            />
            <p
              id="titulo"
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.celular.titulo"
            />
            <p id="subtitulo" class="titulo oscuro subtitulo">
              {{
                !otp
                  ? config.pasos.celular.subtitulo
                  : "Ingresá el código de verificaciónque te enviamos por SMS."
              }}
            </p>
            <otp-input
              v-if="otp"
              v-model="model.otp"
              :maxlength="6"
              :required="true"
              name="otp"
              class="otp-input"
              analyticsTypology="validacion de celular usuario y clave"
            />
            <mobile-number
              name="celular"
              v-else
              v-model="celular"
              :required="true"
              analyticsTypology="validacion de celular usuario y clave"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container class="buttons-container">
            <step-navigator
              v-model="model"
              :disable="!readyValidate"
              store-action="DO_CELULAR"
              :router-push="false"
              v-if="otp"
              @atras="otp = false"
              :routerPushAtras="false"
              :noPadding="true"
            />
            <sales-button
              v-else
              @click="enviarSms"
              :disable="time > 0"
              :label="`Enviar código ${time ? `(${time})` : ''}`"
            />
            <div class="reintentar-container">
              <button
                @click="reenviarSms"
                :style="ReenviarButtonStyle"
                class="reitentar-button"
                v-if="otp"
              >
                {{ time ? `Reenviar código en ${time} seg` : "Reenviar SMS" }}
              </button>
            </div>
          </wrap-container>
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
  </div>
</template>
<!--:color="!time ? '#1973b8' : '#90c2e9'" -->
<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepCounter from "@/components/core/StepCounter";
import StepNavigator from "@/components/core/StepNavigator";
import MobileNumber from "@/components/core/composite/MobileNumber";
import SalesButton from "@/components/core/SalesButton";
import OtpInput from "@/components/core/OtpInput";
import { get, otpIdDevice } from "@/utils/index";

export default {
  name: "Celular",
  components: {
    WrapContainer,
    StepCounter,
    FormValidator,
    StepNavigator,
    MobileNumber,
    SalesButton,
    OtpInput
  },
  data() {
    return {
      otp: false,
      model: this.$store.getters.getCelular(),
      celular: this.$store.getters.getConsulta().celular,
      readyValidate: false,
      time: 0
    };
  },
  methods: {
    enviarSms() {
      let modelCelular = {
        deviceUdid: otpIdDevice(),
        codeOperator: this.celularNormalizado.area,
        mobPhoneNum:
          this.celularNormalizado.caracteristica + this.celularNormalizado.nro
      };
      this.$store.dispatch("DO_ENVIO_CELULAR", modelCelular);
      this.readyValidate = true;
      this.time = 30;
      this.otp = true;
    },
    reenviarSms(event) {
      event.preventDefault();
      if (this.time === 0) {
        this.enviarSms();
      }
    }
  },
  computed: {
    celularNormalizado() {
      return get(this.celular, "normalizado", {
        area: "",
        caracteristica: "",
        nro: ""
      });
    },
    ReenviarButtonStyle() {
      return !this.time ? "color: #1973b8; font-weight: bold;" : "";
    }
  },
  watch: {
    celular: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.model.celular = {
          area: newValue.area,
          numero: newValue.numero,
          normalizado: newValue.normalizado
        };
      }
    },
    time: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.time--;
          }, 1000);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getCelular,
      state => {
        this.model = state;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
.reitentar-button {
  background-color: white;
  border: 0;
  color: rgba(25, 115, 184, 0.4);
  font-size: 15px;
}
.reintentar-container {
  display: flex;
  justify-content: center;
}
.otp-input {
  max-width: 290px;
  margin: 90px auto;
}
.cobranding-logo-header {
  top: 36px;
}
.subtitulo {
  margin-bottom: 32px;
  font-size: 15px;
  line-height: 1.3em;
}

.edit-cel {
  margin: 0;
}

.disable {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.enable {
  cursor: pointer;
}

.d-block {
  display: block;
  margin-top: 10px;
}
</style>
